/* Kardhini — scroll reveal.
   Elements marked .k-reveal fade up once. .k-reveal-group staggers its own
   children via a --k-i index set here rather than in Liquid, so the delay
   survives sections being reordered in the theme editor. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function showAll() {
    document.querySelectorAll('.k-reveal, .k-reveal-group').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function init() {
    // Design mode re-renders sections without a fresh scroll, so anything
    // observed after the initial pass could stay stuck at opacity 0.
    if (reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    document.querySelectorAll('.k-reveal-group').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--k-i', i);
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    document.querySelectorAll('.k-reveal, .k-reveal-group').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // If the visitor turns motion off mid-session, stop hiding content.
  reduced.addEventListener('change', function (e) {
    if (e.matches) showAll();
  });
})();

/* Kardhini — accordions.
   Native <details> opens and closes in a single frame. This animates the
   panel's height instead, for the FAQ and the product page alike. Without JS,
   or with reduced motion, the native toggle still works. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

  function animate(details, panel, from, to, done) {
    if (details._kAnim) details._kAnim.cancel();
    panel.style.overflow = 'hidden';
    // Padding shrinks with the height, or the panel would stop short at its
    // padding and then jump shut.
    var cs = getComputedStyle(panel);
    var pt = panel._kPad ? panel._kPad[0] : cs.paddingTop;
    var pb = panel._kPad ? panel._kPad[1] : cs.paddingBottom;
    panel._kPad = [pt, pb];
    var anim = panel.animate(
      {
        height: [from + 'px', to + 'px'],
        paddingTop: [from ? pt : '0px', to ? pt : '0px'],
        paddingBottom: [from ? pb : '0px', to ? pb : '0px'],
        opacity: [from ? 1 : 0, to ? 1 : 0],
      },
      { duration: 320, easing: EASE }
    );
    details._kAnim = anim;
    anim.onfinish = function () {
      details._kAnim = null;
      panel.style.overflow = '';
      if (done) done();
    };
    anim.oncancel = function () {
      panel.style.overflow = '';
    };
  }

  // Mid-animation the rendered height is the animated one, so a second click
  // reverses from where the panel is rather than jumping.
  function currentHeight(details, panel) {
    return details._kAnim ? parseFloat(getComputedStyle(panel).height) || 0 : panel.offsetHeight;
  }

  function close(details, panel) {
    if (!details.open || details._kClosing) return;
    details._kClosing = true;
    animate(details, panel, currentHeight(details, panel), 0, function () {
      details._kClosing = false;
      details.open = false;
    });
  }

  // Panels sharing a name open one at a time. The browser would shut the
  // others instantly, so the name moves to a data attribute and the closing
  // is animated here instead.
  function init() {
    if (reduced.matches) return;
    document.querySelectorAll('details.k-acc__item[name]').forEach(function (d) {
      d.setAttribute('data-k-group', d.getAttribute('name'));
      d.removeAttribute('name');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('details.k-acc__item > summary');
    if (!summary || reduced.matches || !('animate' in Element.prototype)) return;
    var details = summary.parentElement;
    var panel = summary.nextElementSibling;
    if (!panel) return;
    e.preventDefault();

    // Closing: shrink to zero, then close for real.
    if (details.open && !details._kClosing) {
      close(details, panel);
      return;
    }

    var group = details.getAttribute('data-k-group');
    if (group) {
      document.querySelectorAll('details.k-acc__item[data-k-group="' + group + '"]').forEach(function (other) {
        if (other !== details) close(other, other.querySelector('summary').nextElementSibling);
      });
    }

    // Opening (or reopening mid-close): open first so the panel has a height.
    details._kClosing = false;
    var start = details.open ? currentHeight(details, panel) : 0;
    details.open = true;
    animate(details, panel, start, panel.scrollHeight);
  });
})();
